import { Fragment } from "react";

function DetailBody(props) {
    const { children } = props;
    return <Fragment>{children}</Fragment>;
}

export default DetailBody;
